import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, createBlock as _createBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-295fe280"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-ter part-1" }
const _hoisted_2 = {
  key: 0,
  class: "title-1"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-fanhui" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mh-10 divide" }, null, -1))
const _hoisted_5 = { class: "title-1" }
const _hoisted_6 = {
  key: 0,
  class: "desc-tip"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-divide" }, null, -1))
const _hoisted_8 = { class: "part-2" }
const _hoisted_9 = { class: "part-title flex-ter" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cube" }, null, -1))
const _hoisted_11 = { class: "title-1" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-divide" }, null, -1))
const _hoisted_13 = { class: "part-3" }
const _hoisted_14 = { class: "part-title flex-ter" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cube" }, null, -1))
const _hoisted_16 = { class: "title-1" }
const _hoisted_17 = {
  key: 0,
  class: "customer-auth-condition-style"
}
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "flex-ter" }
const _hoisted_20 = { style: {"margin-right":"5px"} }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "iconfont icon-question",
  style: {"color":"#898989"}
}, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-divide" }, null, -1))
const _hoisted_23 = { class: "part-4" }
const _hoisted_24 = { class: "part-title flex-ter" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cube" }, null, -1))
const _hoisted_26 = { class: "title-1" }
const _hoisted_27 = { class: "flex-col" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-divide" }, null, -1))
const _hoisted_29 = {
  key: 0,
  class: "text-rt part-5",
  style: {"width":"100%"}
}
const _hoisted_30 = {
  class: "text-rt part-6",
  style: {"width":"550px"}
}
const _hoisted_31 = { key: 1 }

import Tip from '@/components/common/Tip.vue'
import { t } from '@/plugins/i18n'
import { useLoading } from '@/views/signup/components/utils'
import { ElMessageBox } from 'element-plus'
import { Plus, Delete } from '@element-plus/icons-vue'
import { h, ref, reactive } from 'vue'
import { useRouter, RouterLink } from 'vue-router'
import { brandQuery, brandAuthDetail, brandAuthApply, brandAuthEdit, brandAuthLastWait } from '@/apis/brand'
import { isJA, useRtfix, useSite2Station } from '@/store'
import { strict } from 'assert'

type Brand = {
  brandName: string;
  brandUrl: string;
  customerAuthTypeList: { label: string, value: number, text: string }[];
  customerAuthCondition: string;
  canJointName: number,
  countryCode: 'KR' | 'CN',
  hasBrandDiscount: number,
  brandCode: string;
};

enum Type {
  ADD = 0,
  EDIT = 1,
}
type CommitType = 0 | 1;


export default /*#__PURE__*/_defineComponent({
  props: {
    id: { type: String, required: false },
    brand: { type: String, required: false },
    width: { type: Number, required: false },
    close: { type: Function, required: false }
  },
  async setup(__props: any) {

let __temp: any, __restore: any

const props = __props as { id?: string; brand?: string; width?: number, close?: () => void }
// 组件在弹窗和新页面两处地方使用
const router = useRouter()



// 授权id
const id = props.id?.toString()

const brand = props.brand?.toString()

// 如果有id查授权详情，如果有brand查最近有没有该品牌的授权详情
const queryApply = () => id ? brandAuthDetail({ applyId: id }) : brand ? brandAuthLastWait({ brandId: brand }) : Promise.resolve({})

const applyData = (
  ([__temp,__restore] = _withAsyncContext(() => queryApply().then(res => {
  if (res?.success) {
    const data = res.data
    if (data) {
      // 有width表示查看详情，如果是过期重新申请，删除applyId
      if (!props.width && data?.applyStatus === 'OVERDUE') {
        delete data.applyId
      }
      if (data.brandInfo) {
        data.brandId = data.brandInfo.brandId
        data.brandCode = data.brandInfo.brandCode
      }
      data.platformUrl = data.platformUrl.split(',')
    }
    return data
  }
}))),
  __temp = await __temp,
  __restore(),
  __temp
)

// 品牌信息
const brandId = props.brand?.toString() ?? applyData.brandId

console.log('brandId', brandId)

const authTypeText = ['普通授权', '独家授权'].map(v => t(v))
const authTypeText2 = ['普通授权字段说明', '独家授权字段说明'].map(v => t(v))

const brandData: Brand = (
  ([__temp,__restore] = _withAsyncContext(() => (brandQuery({ brandId }).setSite(res => {
  if (res.success) {
    const { data } = res
    return {
      brandName: data.brandName,
      brandUrl: data.brandUrl,
      customerAuthTypeList: data.customerAuthTypeList?.map((v: number) => ({
        label: authTypeText[v], value: v, text: authTypeText2[v]
      })),
      canJointName: data.canJointName,
      customerAuthCondition: data.customerAuthCondition,
      countryCode: data.countryCode,
      hasBrandDiscount: data.hasBrandDiscount,
      brandCode: data.brandCode
    }
  } else {
    return {}
  }
})))),
  __temp = await __temp,
  __restore(),
  __temp
)

const brandInfo = reactive(brandData)

console.log(brandInfo)

// 品牌已下架，则查询不到品牌信息，跳转回上一个页面
if (!brandInfo.brandName) {
  setTimeout(() => {
    router.back()
  }, 1000)
}

// 新增 or 编辑
const type: 0 | 1 = applyData?.applyId ? Type.EDIT : Type.ADD

// 如果该审批已提交，不可修改
// 条件即存在id，且状态不为wait
const isSeal = (applyData?.applyId && applyData?.applyStatus !== 'WAIT')

const newone = {
  /** 品牌id */
  brandId,
  /** 0:普通授权 1:独家授权 */
  brandAuthType: brandInfo.customerAuthTypeList[0].value,
  /** 是否需要联名 */
  canJoint: 0,
  /** 用途 */
  content: '',
  /** 联名品牌 */
  jointBrand: '',
  /** 联名需求描述 */
  jointContent: '',
  /** 预计月采购额 */
  planMonthPurAmt: Infinity,
  /** 预计年采购额 */
  planYearPurAmt: Infinity,
  /** 平台链接 */
  platformUrl: [''],
  /** 其他补充说明 */
  remark: '',
  /** 销售平台 */
  salePlatform: '',
  /** 站点 日本:JapanStation 韩国KoreaStation 英国UkStation */
  station: '',
  /** 保存并发布 */
  submit: false
}

const authForm = reactive(
  applyData ?? newone
)

const delPlatFormUrlItem = (index: number) => {
  authForm.platformUrl.splice(index, 1)
}

// 规则
const authRule = {
  brandAuthType: [{ required: true }],
  salePlatform: [{ required: true, message: t('销售平台不能为空') }],
  jointBrand: [{
    validator: (rule: any, value: any, callback: any) => {
      if (authForm.canJoint && !value.trim()) {
        callback(new Error(t('联名品牌不能为空')))
      } else {
        callback()
      }
    }
  }]
}
const formRef = ref()

// 授权条件弹窗
const openPlan = () => {
  ElMessageBox.confirm(h('p', {}, [brandInfo.customerAuthCondition]), t('授权条件'), {
    confirmButtonText: t('确定'),
    cancelButtonText: t('取消')
  })
}

// 提交 0:保存 1:发布
const [loading, commit] = useLoading(async (e: CommitType) => {
  authForm.submit = !!e
  return formRef.value.validate().then((valid: boolean) => {
    if (valid) {
      const params = {
        ...authForm,
        platformUrl: authForm.platformUrl.filter((v: string) => v).join(',')
      }
      const run = type === Type.ADD ? brandAuthApply(params) : brandAuthEdit(params)
      return run.then((res: any) => {
        if (res.success) {
          afterCommit(e)
        }
      })
    }
  }).catch(() => { })
})

// 提交完成弹窗
const afterCommit = (e: CommitType) => {
  let msg = `
      <div>${t(
    e
      ? '提交授权申请后，THE CKB工作人员会在{day}个工作日内联系您。可在工作台-品牌管理查看授权进度'
      : '授权已保存，可在工作台-品牌管理查看授权进度',
    { day: '3-5' }
  )}</div>
  `
  if (brandInfo?.hasBrandDiscount) {
    msg += `<div style='color:red;'>${t('最终优惠折扣，以通过审核后为准。')}</div>`
  }
  ElMessageBox.confirm(msg, t('提示1'), {
    confirmButtonText: t('前往查看'),
    cancelButtonText: t('我知道了'),
    dangerouslyUseHTMLString: true,
    type: 'success'
  }).then(() => {
    router.push(useRtfix('BrandManage'))
  }).catch(() => {
    if (isJA()) {
      location.href = `/choice/brand/${brandInfo?.brandCode}`
    } else {
      router.push(useRtfix('BrandDetail', { params: { brand: brandId } }))
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_unref(brandInfo).brandName)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["flex-col-ter brand-auth-form", __props.width && 'modal'])
      }, [
        _createElementVNode("div", {
          class: "content",
          style: _normalizeStyle({ width: __props.width || 1200 })
        }, [
          _createElementVNode("div", _hoisted_1, [
            (__props.width)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(t)('授权申请')), 1))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("span", {
                    class: "link",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).back()))
                  }, [
                    _hoisted_3,
                    _createTextVNode(" " + _toDisplayString(_unref(t)('返回')), 1)
                  ]),
                  _hoisted_4,
                  _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(t)('新增授权任务')), 1),
                  (_unref(isJA)() && _unref(brandInfo).countryCode === 'KR')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref(t)('提示：审核通过后，默认开通韩元钱包')), 1))
                    : _createCommentVNode("", true)
                ], 64))
          ]),
          _hoisted_7,
          _createVNode(_component_el_form, {
            "label-width": "180px",
            "label-position": "left",
            class: "form"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(t)('品牌信息')), 1)
                ]),
                _createVNode(_component_el_form_item, {
                  label: _unref(t)('品牌名称')
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, _toDisplayString(_unref(brandInfo).brandName), 1)
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _hoisted_12,
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(t)('授权条件')), 1)
                ]),
                _createVNode(_component_el_form_item, {
                  label: _unref(t)('授权条件'),
                  prop: ""
                }, {
                  default: _withCtx(() => [
                    (_unref(brandInfo).customerAuthCondition)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_unref(brandInfo).customerAuthCondition), 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_18, "-"))
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_form_item, {
                  label: _unref(t)('可授权类型'),
                  prop: ""
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("span", _hoisted_20, _toDisplayString(_unref(brandInfo).customerAuthTypeList?.map(v => v.label).join('、')), 1),
                      _createVNode(Tip, null, {
                        content: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(brandInfo).customerAuthTypeList, (v) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: v.value
                            }, _toDisplayString(_unref(t)(v.text)), 1))
                          }), 128))
                        ]),
                        default: _withCtx(() => [
                          _hoisted_21
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }, 8, ["label"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form, {
            model: _unref(authForm),
            "label-width": "180px",
            "label-position": "left",
            rules: authRule,
            class: "form",
            ref: (_value, _refs) => {
              _refs['formRef'] = _value
              formRef.value = _value
            },
            disabled: _unref(isSeal)
          }, {
            default: _withCtx(() => [
              _hoisted_22,
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _hoisted_25,
                  _createElementVNode("span", _hoisted_26, _toDisplayString(_unref(t)('授权申请')), 1)
                ]),
                _createVNode(_component_el_form_item, {
                  label: _unref(t)('用途'),
                  prop: "content"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(authForm).content,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(authForm).content) = $event)),
                      type: "textarea",
                      rows: "4"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_form_item, {
                  label: _unref(t)('平台链接'),
                  prop: "platformUrl"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_27, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(authForm).platformUrl, (i, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "mt_10"
                        }, [
                          _createVNode(_component_el_input, {
                            modelValue: _unref(authForm).platformUrl[index],
                            "onUpdate:modelValue": ($event: any) => ((_unref(authForm).platformUrl[index]) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                          (!_unref(isSeal))
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                (index === 0)
                                  ? (_openBlock(), _createBlock(_component_el_icon, {
                                      key: 0,
                                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(authForm).platformUrl.push(''))),
                                      class: "cursor-pt ml_10"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(Plus))
                                      ]),
                                      _: 1
                                    }))
                                  : (_openBlock(), _createBlock(_component_el_icon, {
                                      key: 1,
                                      class: "cursor-pt ml_10",
                                      onClick: ($event: any) => (delPlatFormUrlItem(index))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(Delete))
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]))
                              ], 64))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_form_item, {
                  label: _unref(t)('预计月采购额（円）'),
                  prop: "planMonthPurAmt"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input_number, {
                      controls: false,
                      min: 0,
                      modelValue: _unref(authForm).planMonthPurAmt,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(authForm).planMonthPurAmt) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_form_item, {
                  label: _unref(t)('其他补充说明'),
                  prop: "remark"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(authForm).remark,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(authForm).remark) = $event)),
                      type: "textarea",
                      rows: "4"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_form_item, {
                  label: _unref(t)('是否需要联名'),
                  prop: "canJoint"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(authForm).canJoint,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(authForm).canJoint) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: _unref(t)('不联名'),
                          value: 0
                        }, null, 8, ["label"]),
                        _createVNode(_component_el_option, {
                          label: _unref(t)('联名'),
                          value: 1
                        }, null, 8, ["label"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                (_unref(authForm).canJoint)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(_component_el_form_item, {
                        label: _unref(t)('联名品牌'),
                        prop: "jointBrand"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _unref(authForm).jointBrand,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(authForm).jointBrand) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_el_form_item, {
                        label: _unref(t)('联名需求描述'),
                        prop: "jointContent"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _unref(authForm).jointContent,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(authForm).jointContent) = $event)),
                            type: "textarea",
                            rows: "4"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label"])
                    ], 64))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["model", "disabled"])
        ], 4),
        _hoisted_28,
        (_unref(isSeal))
          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
              _createVNode(_component_el_button, {
                type: "primary",
                style: {"min-width":"120px"},
                onClick: props.close
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('关闭')), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ]))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              style: _normalizeStyle({ width: __props.width || 1200 })
            }, [
              _createElementVNode("div", _hoisted_30, [
                _createVNode(_component_el_button, {
                  type: "default",
                  style: {"min-width":"100px"},
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_unref(router).back()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('取消')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  type: "primary",
                  loading: _unref(loading),
                  style: {"min-width":"120px"},
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_unref(commit)(0)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('保存1')), 1)
                  ]),
                  _: 1
                }, 8, ["loading"]),
                _createVNode(_component_el_button, {
                  type: "primary",
                  loading: _unref(loading),
                  style: {"min-width":"120px"},
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_unref(commit)(1)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('保存并发布')), 1)
                  ]),
                  _: 1
                }, 8, ["loading"])
              ])
            ], 4))
      ], 2))
    : (_openBlock(), _createElementBlock("div", _hoisted_31, [
        _createElementVNode("div", null, _toDisplayString(_unref(t)('该品牌已下降')), 1)
      ]))
}
}

})